// @flow
import React from 'react';
import ErrorInfo from 'components/etc/ErrorInfo/ErrorInfo';
import { Helmet } from 'react-helmet';
import RespStatus from 'components/etc/RespStatus';

const NotFound = () => {
  return (
    <RespStatus code={404}>
      <Helmet>
        <title>Oops!</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ErrorInfo code="404" message="해당 요청이나 데이터를 찾을 수 없습니다." />
    </RespStatus>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/errors/NotFound.js